import { useContext } from 'react';

import { RequestPushNotificationsContext } from './request-push-notifications-context';

export const useRequestPushNotifications = () =>
  useContext(RequestPushNotificationsContext);
